/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilteredListItem
 */
export interface FilteredListItem {
    /**
     * 
     * @type {number}
     * @memberof FilteredListItem
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FilteredListItem
     */
    readonly idAsString: string;
    /**
     * 
     * @type {string}
     * @memberof FilteredListItem
     */
    name: string | null;
}

/**
 * Check if a given object implements the FilteredListItem interface.
 */
export function instanceOfFilteredListItem(value: object): value is FilteredListItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('idAsString' in value) || value['idAsString'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function FilteredListItemFromJSON(json: any): FilteredListItem {
    return FilteredListItemFromJSONTyped(json, false);
}

export function FilteredListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilteredListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'idAsString': json['idAsString'],
        'name': json['name'],
    };
}

export function FilteredListItemToJSON(json: any): FilteredListItem {
    return FilteredListItemToJSONTyped(json, false);
}

export function FilteredListItemToJSONTyped(value?: Omit<FilteredListItem, 'idAsString'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

